import React, { useState } from "react";
import {
  Box,
  Button,
  HStack,
  Icon,
  IconButton,
  useBoolean,
  VStack,
} from "@chakra-ui/react";

import useTranslate from "hooks/useTranslate";
import useDressingRoom from "hooks/useDressingRoom";
import TinyHeading from "components/TinyHeading";
import TraitTile from "components/TraitTile";
import { FaTimes } from "react-icons/fa";
import StakePopup from "components/StakePopup";
import useTraits from "hooks/useTraits";

const TraitsShelfContainer = () => {
  const translate = useTranslate();
  const { traitsMap } = useTraits();
  const { tokenId, initialTraits, newTraits, color, removeTrait } =
    useDressingRoom();
  const [selectedTraits, setSelectedTraits] = useState<number[] | undefined>();
  const [isStakePopupOpen, setIsStakePopupOpen] = useBoolean();
  const isMultiple = (newTraits?.length || 0) > 1;

  const handleStake = (tokenId: number) => {
    setSelectedTraits([tokenId]);
    setIsStakePopupOpen.on();
  };

  const handleStakeAll = () => {
    setSelectedTraits(newTraits);
    setIsStakePopupOpen.on();
  };

  return tokenId && newTraits?.length && traitsMap ? (
    <>
      <VStack
        bg="dark.400"
        w="full"
        spacing="2px"
        pt="3"
        color="bright.500"
        align="flex-start"
      >
        <TinyHeading px="4" mb="3" mt="2px">
          {translate("dressing:title")}
        </TinyHeading>

        {newTraits.map((tokenId) => {
          const trait = traitsMap[tokenId];

          return trait ? (
            <Box key={tokenId} w="full">
              <TraitTile
                tokenId={tokenId}
                name={trait.name}
                color={color}
                canvasSize={{
                  base: "14",
                  sm: "16",
                }}
              >
                <HStack spacing="3" p="1.5">
                  <Button size="sm" onClick={() => handleStake(tokenId)}>
                    {translate("common:stake")}
                  </Button>

                  <IconButton
                    size="sm"
                    aria-label=""
                    icon={<Icon as={FaTimes} />}
                    borderRadius="full"
                    colorScheme="dark"
                    onClick={() => removeTrait(tokenId)}
                  ></IconButton>
                </HStack>
              </TraitTile>
            </Box>
          ) : null;
        })}
      </VStack>

      {isMultiple && (
        <Box p="4" bg="dark.400">
          <Button w="full" onClick={handleStakeAll}>
            {translate("dressing:stakeAll", { count: newTraits.length })}
          </Button>
        </Box>
      )}

      {selectedTraits && color && (
        <StakePopup
          isOpen={isStakePopupOpen}
          initialTraits={initialTraits}
          tokenId={tokenId}
          newTraits={selectedTraits}
          color={color}
          onClose={setIsStakePopupOpen.off}
        />
      )}
    </>
  ) : null;
};

export default TraitsShelfContainer;
